import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/LogIn.vue';
import FileUploader from '../components/FileUploader.vue';
import MainPage from '../components/MainPage.vue';
import Articles from '../components/Articles.vue';
import Queue from '../components/Queue.vue';
import Alliance from '../components/Alliance.vue';
import Federated from '../components/Federated.vue';
import MyPage from '../components/MyPage.vue';
import UpdateUser from '../components/UpdateUser.vue';
import SignUp from '../components/SignUp.vue';
import Invite from '../components/Invite.vue';
import MemberList from '../components/MemberList.vue';
import ArticleInfo from '../components/ArticleInfo.vue';


const routes = [
  {
    path: '/',
    name: 'MainPage',
    component: MainPage,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/users/signup',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/admin/invite',
    name: 'Invite',
    component: Invite,
  },
  {
    path: '/admin/user/list',
    name: 'Member List',
    component: MemberList,
  },
  {
    path: '/articles',
    name: 'Article List',
    component: Articles,
  },
  {
    path: '/articleinfo',
    name: 'Article Info',
    component: ArticleInfo,
  },
  {
    path: '/articles/federated',
    name: 'Federated Article List',
    component: Federated,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: MyPage,
  },
  {
    path: '/alliance',
    name: 'Alliance',
    component: Alliance,
  },
  {
    path: '/users/update',
    name: 'Update user information',
    component: UpdateUser,
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/articles/queue',
    name: 'Articles waiting for approval',
    component: Queue,
    meta: { requiresAuth: true },
  },
  {
    path: '/articles/submit',
    name: 'Upload Article',
    component: FileUploader,
    meta: { requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)*', // Catch-all route for undefined paths
    redirect: '/login', // Redirect unknown paths to the login page
  },
];

const router = createRouter({
  history: createWebHistory(), // Use the HTML5 history mode
  routes,
});

// Navigation guard to protect routes that require authentication
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('jwt');
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;

